export default {
  home: {
    'deviceSum': 'Device sum',
    'onlineDevice': 'Online device',
    'alarmQuantity': 'Alarm quantity',
    'offDevice': 'Off device',
    'deviceList':'Device list',
    'map':'map',
    'deviceInfo':'Device information',
    'deviceName':'Device name',
    'groupId':'Group id',
    'onlineState':'Online state',
    'deviceOffTime':'Device off time',
    'deviceOnlineTime':'Device online time',
    'createTime':'CreateTime',
    'featureInfo':'Information element',
    'noData': 'No data',
    'groupNoDevice':'The current group has no device',
    'offLine': 'Off line',
    'onLine': 'On line',
  },
  arg: {
    'closeDialog':'Are you sure it\'s off?',
    'viewCurve': 'View curve',
    'historicalData': 'Historical data',
    'query': 'Query',
    'exportData': 'Export data',
    'noTime': 'The start time and end time cannot be empty',
    'noTimeRange': 'Time frame is too long',
    'noAtr': 'property cannot be empty',
  },
  group: {
    'defaultGroup': 'Default group',
    'groupList' :'Scene list',
    'inputGroupName': 'Please enter a scene name',
    'selectGroupState': 'Please select the scene state',
    'inputDeviceName': 'Please enter the device name',
    'editSuccess': 'Edit successfully',
    'editFail': 'Edit failure',
    'confirmSubmission': 'Do you confirm submission?',
    'tip': 'Tip',
    'confirm': 'Confirm',
    'cancel': 'Cancel',
    'addSuccess': 'Add successfully',
    'addFail': 'Add failure',
    'sureDeleteScene' :'Are you sure to delete the current scene?',
    'successDelete': 'Successfully delete',
    'undelete' : 'Undelete',
    'search': 'Search',
    'newScene': 'New scene',
    'edit' :'Edit',
    'sceneName': 'Scene name',
    'sceneState': 'Scene state',
    'usable':'Usable',
    'forbidden': 'Forbidden',
    'submit': 'Submit'
  },
  device: {
    'noteNameTip':'Please fill in the remark name',
    'noteName':'Note Name',
    'devicename':'Device name',
    'homeGroup': 'Home group',
    'longitude': 'Longitude',
    'latitude':'Latitude',
    'deviceNameSearch': 'Please enter the device name to search',
    'equipmentInformation': 'Equipment information',
    'ProductOwnership': 'Product of ownership',
    'creationTime': 'creation time',
    'operation':'Operation'
  },
  alarm: {
    'runningStatus': 'running status',
    'close':'stop',
    'open':'running',
    'handleOpen': 'running',
    'passageway':'Notification channel',
    'selectPassageway':'Please select a notification channel',
    'alarmRule':'Alarm rule',
    'searchTitle': 'Enter the alarm title to search for alarms',
    'add': 'Added',
    'edit': 'Edit',
    'triggerType':'Trigger type',
    'attributeChange': 'Device attribute change',
    'deviceOffLine': 'Device offline',
    'hitCount': 'Hit count',
    'duration':'Duration',
    'alarmCondition':'Alarm condition',
    'notRelease':'Not release',
    'haveReleased':'Have released',
    'soldOut':'Sold out',
    'alarmName':'Alarm name',
    'selectDevice':'Please select an active device',
    'conditionList': 'Condition list',
    'and&or': 'Please select and, or',
    'attribute': 'Attribute',
    'selectCondition':'Please select a condition',
    'delete':'delete',
    'enterContent': 'Please enter content',
    'addCondition':'Add condition',
    'alarmLevel':'Alarm level',
    'notificationChannel':'Notification channel',
    'advancedOptions':'Advanced options',
    'manuallyAlarm':'Manually clear an alarm',
    'selectManually':'Select manually clear the alarm',
    'startTime': 'Start time',
    'endTime': 'End time',
    'effectivePeriod': 'Effective period',
    'noTimeSelect':'No time period is selected',
    'experienceTime':'To experience custom timing (notifications are more flexible)',
    'returnTime':'Return to the traditional time interval Settings',
    'support':'Support',
    'nonsupport':'Nonsupport',
    'notificationPeriod':'Notification period',
    'general':'General',
    'significance':'Significance',
    'seriousness':'Seriousness',
    'minute':'minute',
    'second':'second',
    'time': 'time',
    'alarmNameNot':'The alarm name cannot be empty',
    'sourceTypeNot':'The data source type cannot be empty',
    'sourceNot': 'The device source cannot be empty',
    'triggerTypeNot':'The trigger type cannot be empty',
    'conditionsNot':'The list of conditions cannot be empty',
    'severityNot':'The alarm severity cannot be empty',
    'manuallyNot':'Manually clear the alarm. The value cannot be empty',
    'success':'Success',
    'fail':'Fail',
    'and':'And',
    'or':'Or',
    'greaterThan':'Greater Than',
    'equalOrGreater':'Be equal or greater than',
    'lessThan':'Less than',
    'lessEqual':'Less than or equal to',
    'equalTo':'Equal to',
    'unequalTo':'unequal to',
    'selectActiveDevice':'Please select an active device',
  },
  inform: {
    'warningMessage':'Warning message',
    'pending':'pending',
    'automaticResolution':'Automatic resolution',
    'manualSolution':'Manual solution',
  },
  notification: {
    'notificationChannelName':'Notification channel name',
    'notificationWay':'the way of notification',
    'sureDelete':'Are you sure to delete it?',
    'emailEmpty':'The email address cannot be empty',
    'emailFormat':'The email address format is incorrect',
    'nameEmpty':'The notification name cannot be empty',
    'typeEmpty':'The notification type cannot be empty',
    'updateSuccessfully':'update successfully',
    'createdSuccessfully':'Created successfully',
    'email':'mailbox',
    'emailAddress':'e-mail address',
    'phoneMessage':'phone number',
    'invalidPhoneMessage': 'Invalid mobile phone number'
  },
  profile: {
    'enterNickname':'Please enter a nickname',
    'enterEmail':'Please enter email',
    'validEmail':'Please enter a valid email address',
    'enterNumber':'Please enter your phone number',
    'enterValidNumber':'Please enter a valid phone number',
    'modifySuccessfully':'modify successfully',
    'failModify':'fail to modify',
    'enterOldPassword':'Please enter your old password',
    'enterNewPassword':'Please enter your new password',
    'characters':'The password must contain at least 6 characters',
    'confirmNewPassword':'Please confirm the new password',
    'twoPasswordsDifferent':'The two new passwords are different',
    'passwordSuccessfully':'Password changed successfully',
    'essentialInformation':'essential information',
    'failedPassword':'Failed to change the password',
    'nickname':'User nickname',
    'phoneNumber':'Subscriber\'s mobile phone number',
    'userMailbox':'User mailbox',
    'changePassword':'change password',
    'oldPassword':'old password',
    'newPassword':'new password',
    'confirmNewPasswordLabel':'Confirm new password',
    'editAvatar':'Edit avatar',
    'username':'username',
    'callPhoneNumber':'cell phone number',
    'loginTime':'log-in time',
    'myAPP': 'My App',
    'verificationCode':'verification code',
    'enterVerificationCode': 'Please enter the verification code',
    'bindPhoneNumber': 'bind account to a mobile phone number',
    'updatePhoneNumber': 'Update mobile phone number',
    'update': 'update',
    'close': 'close',
    'open': 'open',
    'applicationName': 'Application name',
    'getCode':'get code',
    'key':'key',
    'status': 'status',
    'sureChange': 'Are you sure you want to change this?'
  },
  message: {
    'messageTip': 'message',
    'noNewsYet':'No news yet',
    'markedRead':'Marked read',
    'notificationMessage':'notification message',
    'allRead':'All read',
    'markRead':'Mark read',
    'read':'read'
  },
  base:{
    'navigation':'Navigation',
    'own':'Personal Center',
    'help':'Do you need any help?',
    'helpDesc':'We can provide you with the following assistance.',
    'softwareSupport':'IoT technology support',
    'hardwareSupport':'Equipment technical support',
    'essentialInformation':'essential information'
  },
  routesMenu:{
    'homePage':'Home Page',
    'data':'Data center',
    'device':'Equipment Center',
    'alarm':'Alarm Center',
    'inform':'Alarm Inform',
    'notification':'Notification channel',
    'arrange':'Equipment arrangement',
    'me':'personal center',
    'message':'Message Center'
  },
  login: {
    'userTerms':'User terms',
    'iAgree': 'I agree',
    'captchaSuccess':'captcha.success',
    'rememberMe':'Remember me',
    'captchaFail': 'captcha.fail',
    'signIn': 'Sign in',
    'welcome': 'Welcome to the ',
    'company':'Handan Yunnong Intelligent Agricultural Technology Co., Ltd',
    'yantaiCompany': 'Handan Yantai Import and Export Co., Ltd',
    'companyProfile':'<p class="text-white position-relative">\n' +
        '                  Our products cover the fields of sunlight, air, soil, and water environment, utilizing wireless communication technology and convenient mobile operation to serve customers. We provide hundreds of thousands of sensors and are a well-known supplier of sensor products and digital solutions in the industry.\n' +
        '                </p>\n' +
        '                <p class="text-white position-relative">\n' +
        '                  The company adheres to the cultural concept of "integrity, integration, innovation, and sharing", and is willing to contribute to the realization of the new era development concept of "Digital China" with upstream and downstream customers, and provide a reliable monitoring network and sustainability guarantee for the environment on which human survival depends!\n' +
        '                </p>',
    'yantaiCompanyProfile': '<p class="text-white position-relative">\n' + 'Handan Yantai Import and Export Co., Ltd' + '</p>\n' +
      '                <p class="text-white position-relative">\n' +
        'Our products cover the fields of sunlight, air, soil, and water environment, utilizing wireless communication technology and convenient mobile operation to serve customers. We provide hundreds of thousands of sensors and are a well-known supplier of sensor products and digital solutions in the industry.'
      + '</p>\n' + '<p class="text-white position-relative">\n' + 'The company adheres to the cultural concept of "integrity, integration, innovation, and sharing", and is willing to contribute to the realization of the new era development concept of "Digital World" with upstream and downstream customers, and provide a reliable monitoring network and sustainability guarantee for the environment on which human survival depends!' +
      '</p>'
  },
  site:{
    'yantaiTitle':'yantai',
    'primaryName':'Fields on the Cloud',
    'name':' (IoT) Platform'
  },
  navbar:{
    'businessCaseName':'Business Case',
    'businessCaseUrl':'http://nong-iot.cn/business-case.html',
    'businessConsultingName':'Business Consulting',
    'businessConsultingUrl':'http://nong-iot.cn/consult.html',
    'aboutUsName':'About Us',
    'aboutUsNameUrl':'http://nong-iot.cn/about-us.html',
    'productCenterName':'Product Center',
    'productCenterNameUrl':'http://nong-iot.cn/'
  },
  configurator:{
    'theme': 'Theme configuration',
    'themeOptions':'View the theme options we support.',
    'sidebarColors':'Sidebar color',
    'sidenavType':'Left navigation bar',
    'sidenavDesc':'Mode switching supports both light and dark modes',
    'white':'White',
    'dark':'Dark',
    'navbarFixed':'Navbar Fixed',
    'themeSwitching':'Light / Dark',
    'quit': 'Exit'
  },
  element: {
    "空气温度": "Air Temperature",
    "空气湿度": "Air Humidity",
    "大气压强": "Atmospheric Pressure",
    "风速": "Wind Speed",
    "风向": "Wind Direction",
    "降雨量": "Rainfall",
    "蒸发量": "Evaporation",
    "土壤温度": "Soil Temperature",
    "土壤湿度": "Soil Humidity",
    "土壤EC": "Soil EC",
    "土壤EC2": "Soil EC2",
    "土壤EC3": "Soil EC3",
    "土壤PH": "Soil PH",
    "光照强度": "Light Intensity",
    "光合有效": "Photosynthetically Active Radiation",
    "总辐射": "Total Radiation",
    "总辐射累积量": "Cumulative Total Radiation",
    "水平辐射": "Horizontal Radiation",
    "水平辐射累积量": "Cumulative Horizontal Radiation",
    "斜面辐射": "Slope Radiation",
    "斜面辐射累积量": "Cumulative Slope Radiation",
    "散射辐射": "Scattered Radiation",
    "散射辐射累积量": "Cumulative Scattered Radiation",
    "直接辐射": "Direct Radiation",
    "直接辐射累积量": "Cumulative Direct Radiation",
    "紫外指数": "UV Index",
    "紫外辐射": "Ultraviolet Radiation",
    "日照时数": "Sunshine Duration",
    "噪声": "Noise",
    "PM2.5": "PM2.5",
    "PM10": "PM10",
    "CO2": "CO2",
    "SO2": "SO2",
    "CO": "CO",
    "O3": "O3",
    "H2S": "H2S",
    "NO2-1": "NO2-1",
    "NO2-2": "NO2-2",
    "叶面温度": "Leaf Temperature",
    "叶面湿度": "Leaf Humidity",
    "组件温度": "Module Temperature",
    "露点温度": "Dew Point Temperature",
    "小时雨量": "Hourly Rainfall",
    "24小时雨量": "24-Hour Rainfall",
    "连续雨量": "Continuous Rainfall",
    "水温": "Water Temperature",
    "水PH": "Water PH",
    "水EC": "Water EC",
    "溶氧": "Dissolved Oxygen",
    "浊度": "Turbidity",
    "NH3": "Ammonia",
    "暴晒温度": "Exposure Temperature",
    "微气象风速": "Microclimate Wind Speed",
    "微气象风向": "Microclimate Wind Direction",
    "设备电压": "Device Voltage",
    "设备电量": "Device Power",
    "TSP(PM)100": "TSP (PM100)",
    "负氧离子": "Negative Oxygen Ions",
    "流速(多普勒)": "Flow Velocity (Doppler)",
    "液位(超声)": "Liquid Level (Ultrasonic)",
    "液位(压力)": "Liquid Level (Pressure)",
    "能见度": "Visibility",
    "路面状况路面温度": "Road Surface Temperature",
    "路面状况积水深度": "Road Surface Water Depth",
    "路面状况冰厚度": "Road Surface Ice Thickness",
    "路面状况雪厚度": "Road Surface Snow Thickness",
    "路面状况湿滑系数": "Road Surface Slippery Coefficient",
    "路面状况路面状态": "Road Surface Status",
    "GPS东西经": "GPS Longitude (East-West)",
    "GPS经度": "GPS Longitude",
    "GPS南北纬": "GPS Latitude (North-South)",
    "GPS纬度": "GPS Latitude",
    "TVOC": "TVOC",
    "雨雪报警": "Rain/Snow Alarm",
    "电池电压": "Battery Voltage",
    "太阳能电压": "Solar Voltage",
    "信号强度": "Signal Strength",
    "果实膨大": "Fruit Expansion",
    "氨氮": "Ammonia Nitrogen",
    "水膜厚度": "Water Film Thickness",
    "土壤硬度": "Soil Hardness",
    "蒸腾量": "Transpiration",
    "EC": "EC",
    "前置冲洗时间": "Prewash Time",
    "轮灌间隔": "Irrigation Interval",
    "轮灌次数": "Irrigation Count",
    "水肥机工作模式": "Fertilizer Machine Mode",
    "水肥机状态": "Fertilizer Machine Status",
    "水泵状态": "Water Pump Status",
    "PH": "PH",
    "肥泵状态": "Fertilizer Pump Status",
    "目标EC": "Target EC",
    "目标PH": "Target PH",
    "后置冲洗时间": "Postwash Time",
    "主水源瞬时流量": "Main Water Source Instantaneous Flow",
    "主水源累积流量": "Main Water Source Cumulative Flow"
  }

};
